import _ from 'lodash';


type erro = {
    [key: string]: any;
}

interface TheForm {
   error: erro;
   defaults: {[key: string]: any}; 
   [key: string]: any;
}







class MyForm implements TheForm {
    [key: string]: any;
    error: erro;
    defaults: {[key: string]: any} 

    constructor(defaults = {}) {
        this.error = {};
        this.defaults = defaults;
        if (this.defaults) {
            Object.assign(this, this.defaults);
        }
    }
    

    hasError(field: string | number): boolean {
        return this.error.hasOwnProperty.call(this, field);
    }

    errorOut(field: string) {
        let b;
        _.forEach(this.error, (sms: Array<string>, key: string | number) => {
            if (key === field) {
                b = sms[0];
            }
        });

        return b
    }

    clearAll(): object {
        return this.error = {}
    }

    clear(field: string) {
            delete this.error[field]

    }

    any() {
        return _.isEmpty(this.error);
    }

    reset(): string | this {
        const fields = Object.keys(this);
        _.forEach(fields, (value: string | number) => {
            this[value] = '';
        });

        return this;
    }

}

export default MyForm;